import { deleteReportEventsItem, getAllReportEventsItems } from 'src/api/report-events/offlineReportEventsApi';
import useApi from 'src/api/useApi';
import { useSWService } from 'src/api/sw/useSWService';

const useSyncOfflineReportEvents = () => {
    const { postApiData } = useApi();
    const { refreshRequestsContaining } = useSWService();

    const syncReportEvents = async (skipRefresh?: boolean | null): Promise<void> => {
        const reportEventsItems = await getAllReportEventsItems();
        reportEventsItems.sort((a, b) => a.lastUpdated - b.lastUpdated);

        for (let i = 0; i < reportEventsItems.length; i++) {
            const item = reportEventsItems[i];
            const request = item.deleteEventRequest ?? item.updateEventRequest ?? item.createEventRequest;

            if (request) {
                try {
                    const response = await postApiData({ fullUrl: request.url, data: request.body, skipRefreshCacheEndpoints: i < reportEventsItems.length - 1 });
                    if (response) {
                        await deleteReportEventsItem(item.eventId);
                    }
                } catch (error) {
                    console.warn('Failed to sync report event item, will retry next cycle.', item.eventId, error);
                }
            }
        }

        if (!skipRefresh) {
            await refreshRequestsContaining(['GetEvents', 'GetDeltaEvents']);
        }
    };

    return {
        syncReportEvents,
    };
};

export default useSyncOfflineReportEvents;
